const state = {
  currentPrize: null
};

const getters = {
  currentPrize: (state) => state.currentPrize,
};

const actions = {
  async setCurrentPrize({ commit }, payload) {
    commit("setCurrentPrize", payload);
  },
};

const mutations = {
    setCurrentPrize: (state, currentPrize) => {
    state.currentPrize = currentPrize;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
